<template>
  <v-text-field
      :class="['date-picker-input',{'v-input--focused' : activeMenu}]"
      variant="solo"
      v-model="timeReformate"
      :placeholder="placeholder"
      @click="activeMenu = !activeMenu"
      readonly
  >
    <template v-slot:append-inner>
      <icon-calendar/>
    </template>
    <v-menu
        v-model="activeMenu"
        :close-on-content-click="false"
        activator="parent"
        transition="scale-transition"
    >
      <v-date-picker
          prev-icon="mdi-arrow-left"
          next-icon="mdi-arrow-right"
          :first-day-of-week="1"
          :locale="'ru'"
          :hide-header="true"
          v-model="time"
          full-width
      >
      </v-date-picker>
    </v-menu>
  </v-text-field>
</template>

<script>

import IconDefault from "@/components/shared/icons/IconDefault.vue";
import IconArrow from "@/components/shared/icons/IconArrow.vue";
import IconCalendar from "@/components/shared/icons/IconCalendar.vue";

export default {
  name: "PickerMenuDate",
  components: {IconCalendar, IconArrow, IconDefault},
  props: {
    placeholder: {
      type: String,
      default: 'Дата'
    },
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      time: null,
      activeMenu: false,
      timeReformate: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      if(this.value) {
        this.time = this.value;
      }
    })
  },
  watch: {
    value() {
      if (this.value) {
        this.time = this.value;
      }
    },
    time() {
      this.activeMenu = false;
      const date = new Date(this.time);

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      this.timeReformate = `${day}.${month}.${year}`;
      this.$emit('changeDate', this.time);
    }
  }
}
</script>

<style scoped lang="scss">
</style>